import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = [] as PurchaserDetails[];

const slice = createSlice({
  name: '$requiredPurchaserDetails',
  initialState,
  reducers: {
    setRequiredPurchaserDetails(
      state,
      action: PayloadAction<PurchaserDetails[]>,
    ) {
      return action.payload || [];
    },
  },
});

export const { setRequiredPurchaserDetails } = slice.actions;
export default slice.reducer;
